import axios from "axios";
const API_URL = "https://vestshop-api.vercel.app/api"
export const newOrder = async (order , id) => {
    try{
        const res = await axios.post(`${API_URL}/addOrder/${id}` , order)
        return res.data
    }catch(err){
        console.log(err)
    }
}
export const userorder = async (id) => {
    try{
        const res = await axios.get(`${API_URL}/userorder/${id}`)
        return res.data
    }catch(err){
        console.log(err)
    }
}
